// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Router from "next/router";
import * as Config$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/configs/Config.mjs";
import * as StringUtils$Catalyst from "../../../../../../../node_modules/@porterin/catalyst/src/utils/StringUtils.mjs";
import * as JsBindings$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/bindings/common/JsBindings.mjs";
import * as AuthContext$PorterinFeature from "../../../../contexts/auth-context/AuthContext.mjs";
import * as CommonHelper$PorterinFeature from "../../../core/helpers/CommonHelper.mjs";
import * as LocaleConstants$PorterinUtils from "../../../../../../../node_modules/@porterin/utils/src/constants/LocaleConstants.mjs";
import * as FareEstimateForm$PorterinFeature from "../../../lead-flow/view/component/form/FareEstimateForm.mjs";
import * as GAEventsConstants$PorterinFeature from "../../../core/constants/GAEventsConstants.mjs";
import * as FareEstimateHelper$PorterinFeature from "../../../core/helpers/FareEstimateHelper.mjs";
import * as PublishEventsHelper$PorterinFeature from "../../../core/helpers/PublishEventsHelper.mjs";
import * as SpotEstimateInputCmp$PorterinFeature from "./SpotEstimateInputCmp.mjs";
import * as SpotEstimateFormState$PorterinFeature from "./form/SpotEstimateFormState.mjs";
import * as AutocompleteDropdownStyles$PorterinFeature from "../../../auto-complete/view/styles/AutocompleteDropdownStyles.mjs";
import * as SpotEstimateRequirementCmp$PorterinFeature from "./SpotEstimateRequirementCmp.mjs";
import * as SpotEstimateFormFieldModuleScss from "../styles/SpotEstimateFormField.module.scss";
import * as FareEstimateResultFormHelper$PorterinFeature from "../../../core/helpers/FareEstimateResultFormHelper.mjs";
import * as GoogleReactAutocompleteCmpMod$PorterinFeature from "../../../auto-complete/view/components/GoogleReactAutocompleteCmpMod.mjs";

var styles = SpotEstimateFormFieldModuleScss;

function SpotEstimateFormFieldCmp(Props) {
  var form = Props.form;
  var response = Props.response;
  var service_category = Props.service_category;
  var city_selected_context = Props.city_selected_context;
  var spot_fare_estimate_vm = Props.spot_fare_estimate_vm;
  var icons = spot_fare_estimate_vm.icons;
  var labels = spot_fare_estimate_vm.labels;
  var match = AuthContext$PorterinFeature.useAuthContext(undefined);
  var is_authenticated = match.is_authenticated;
  var match$1 = Router.useRouter();
  var locale = match$1.locale;
  var pickupAddressOnChange = function (addressValue, _postalAddress) {
    Curry._2(form.updatePickup_address, (function (input, value) {
            return {
                    pickup_address: value,
                    drop_address: input.drop_address,
                    name: input.name,
                    mobile: input.mobile,
                    requirement: input.requirement,
                    consent_for_callback: input.consent_for_callback
                  };
          }), addressValue);
  };
  var dropAddressOnChange = function (addressValue, _postalAddress) {
    Curry._2(form.updateDrop_address, (function (input, value) {
            return {
                    pickup_address: input.pickup_address,
                    drop_address: value,
                    name: input.name,
                    mobile: input.mobile,
                    requirement: input.requirement,
                    consent_for_callback: input.consent_for_callback
                  };
          }), addressValue);
  };
  var getFieldError = function (field, callback) {
    var match = Curry._1(form.dirty, undefined);
    if (response === undefined) {
      return CommonHelper$PorterinFeature.getError(field);
    }
    if (response.TAG === /* Ok */0) {
      return CommonHelper$PorterinFeature.getError(field);
    }
    var form_error = response._0;
    if (form_error.TAG === /* FareEstimateHashError */0 || match) {
      return CommonHelper$PorterinFeature.getError(field);
    } else {
      return Curry._1(callback, Belt_Option.getWithDefault(form_error._0.field_errors, FareEstimateForm$PorterinFeature.inital));
    }
  };
  var requirementString = function (param) {
    var val = form.input.requirement;
    if (val !== undefined) {
      return StringUtils$Catalyst.snakeCaseToTitleCase(FareEstimateHelper$PorterinFeature.requirementToLabel(val, spot_fare_estimate_vm.requirement_options));
    } else {
      return "";
    }
  };
  var getFormErrorMessage = function (param) {
    var match = Curry._1(form.dirty, undefined);
    if (response === undefined) {
      return "";
    }
    if (response.TAG === /* Ok */0) {
      return "";
    }
    var form_error = response._0;
    if (form_error.TAG === /* FareEstimateHashError */0) {
      if (match) {
        return "";
      } else {
        return form_error._0;
      }
    } else if (match) {
      return "";
    } else {
      return Belt_Option.getWithDefault(form_error._0.form_error, "");
    }
  };
  var dropdownStyles = function (param) {
    var match = city_selected_context.category;
    if (match === "Home" && is_authenticated) {
      return AutocompleteDropdownStyles$PorterinFeature.menuStyleAuthenticated;
    } else {
      return AutocompleteDropdownStyles$PorterinFeature.menuStyle;
    }
  };
  return React.createElement("form", {
              className: styles["fare-estimate-form"],
              onSubmit: (function ($$event) {
                  $$event.preventDefault();
                  Curry._1(form.submit, undefined);
                })
            }, React.createElement("div", {
                  className: styles.location
                }, React.createElement(SpotEstimateInputCmp$PorterinFeature.make, {
                      label: labels.pickup,
                      is_required: true,
                      is_filled: form.input.pickup_address.landmark.length === 0,
                      children: JsBindings$PorterinUtils.isBrowser(undefined) ? React.createElement(GoogleReactAutocompleteCmpMod$PorterinFeature.make, {
                              id: "pickup-address-" + String(Math.random()) + "",
                              value: form.input.pickup_address.landmark,
                              api_key: Config$PorterinUtils.google_maps_api_key,
                              form_on_change: pickupAddressOnChange,
                              placeholder: "",
                              wrapperStyle: AutocompleteDropdownStyles$PorterinFeature.wrapperStyle,
                              menuStyle: dropdownStyles(undefined),
                              inputClass: "" + styles["pickup-input"] + " " + (
                                form.submitting ? styles.disabled : ""
                              ) + "",
                              itemClass: styles["dropdown-item"]
                            }) : null,
                      error: FareEstimateResultFormHelper$PorterinFeature.getAddressFieldError(form.pickup_addressResult, (function (field_errors) {
                              return field_errors.pickup;
                            }), response, FareEstimateResultFormHelper$PorterinFeature.addressFieldError(Curry._1(form.dirty, undefined), /* Pickup */0, spot_fare_estimate_vm.errors_msgs.pickup)),
                      input_image: icons.pickup,
                      clear_input: (function ($$event) {
                          Curry._2(form.updatePickup_address, (function (input, param) {
                                  return {
                                          pickup_address: SpotEstimateFormState$PorterinFeature.initalAddress,
                                          drop_address: input.drop_address,
                                          name: input.name,
                                          mobile: input.mobile,
                                          requirement: input.requirement,
                                          consent_for_callback: input.consent_for_callback
                                        };
                                }), $$event.target.value);
                        })
                    }), React.createElement("div", {
                      className: styles["location-dash"]
                    }), React.createElement(SpotEstimateInputCmp$PorterinFeature.make, {
                      label: labels.drop,
                      is_required: true,
                      is_filled: form.input.drop_address.landmark.length === 0,
                      children: JsBindings$PorterinUtils.isBrowser(undefined) ? React.createElement(GoogleReactAutocompleteCmpMod$PorterinFeature.make, {
                              id: "pickup-address-" + String(Math.random()) + "",
                              value: form.input.drop_address.landmark,
                              api_key: Config$PorterinUtils.google_maps_api_key,
                              form_on_change: dropAddressOnChange,
                              placeholder: "",
                              wrapperStyle: AutocompleteDropdownStyles$PorterinFeature.wrapperStyle,
                              menuStyle: dropdownStyles(undefined),
                              inputClass: "" + styles["pickup-input"] + " " + (
                                form.submitting ? styles.disabled : ""
                              ) + "",
                              itemClass: styles["dropdown-item"]
                            }) : null,
                      error: FareEstimateResultFormHelper$PorterinFeature.getAddressFieldError(form.drop_addressResult, (function (field_errors) {
                              return field_errors.drop;
                            }), response, FareEstimateResultFormHelper$PorterinFeature.addressFieldError(Curry._1(form.dirty, undefined), /* Dropoff */1, spot_fare_estimate_vm.errors_msgs.drop)),
                      input_image: icons.drop,
                      clear_input: (function ($$event) {
                          Curry._2(form.updateDrop_address, (function (input, param) {
                                  return {
                                          pickup_address: input.pickup_address,
                                          drop_address: SpotEstimateFormState$PorterinFeature.initalAddress,
                                          name: input.name,
                                          mobile: input.mobile,
                                          requirement: input.requirement,
                                          consent_for_callback: input.consent_for_callback
                                        };
                                }), $$event.target.value);
                        })
                    })), is_authenticated ? null : React.createElement(React.Fragment, undefined, React.createElement(SpotEstimateInputCmp$PorterinFeature.make, {
                        label: labels.name,
                        is_required: true,
                        is_filled: form.input.name.length === 0,
                        children: React.createElement("input", {
                              className: styles["name-input"],
                              disabled: form.submitting,
                              placeholder: "",
                              type: "text",
                              value: form.input.name,
                              onBlur: (function (param) {
                                  Curry._1(form.blurName, undefined);
                                }),
                              onChange: (function ($$event) {
                                  Curry._2(form.updateName, (function (input, value) {
                                          return {
                                                  pickup_address: input.pickup_address,
                                                  drop_address: input.drop_address,
                                                  name: value,
                                                  mobile: input.mobile,
                                                  requirement: input.requirement,
                                                  consent_for_callback: input.consent_for_callback
                                                };
                                        }), $$event.target.value);
                                })
                            }),
                        error: getFieldError(form.nameResult, (function (field_errors) {
                                return field_errors.name;
                              })),
                        input_image: icons.name,
                        clear_input: (function ($$event) {
                            Curry._2(form.updateName, (function (input, param) {
                                    return {
                                            pickup_address: input.pickup_address,
                                            drop_address: input.drop_address,
                                            name: "",
                                            mobile: input.mobile,
                                            requirement: input.requirement,
                                            consent_for_callback: input.consent_for_callback
                                          };
                                  }), $$event.target.value);
                          })
                      }), React.createElement(SpotEstimateInputCmp$PorterinFeature.make, {
                        label: labels.phone,
                        is_required: true,
                        is_filled: form.input.mobile.length === 0,
                        children: React.createElement("input", {
                              className: styles["mobile-input"],
                              disabled: form.submitting,
                              maxLength: 11,
                              placeholder: "",
                              type: "tel",
                              value: form.input.mobile,
                              onBlur: (function (param) {
                                  Curry._1(form.blurMobile, undefined);
                                }),
                              onChange: (function ($$event) {
                                  Curry._2(form.updateMobile, (function (input, value) {
                                          return {
                                                  pickup_address: input.pickup_address,
                                                  drop_address: input.drop_address,
                                                  name: input.name,
                                                  mobile: value,
                                                  requirement: input.requirement,
                                                  consent_for_callback: input.consent_for_callback
                                                };
                                        }), $$event.target.value);
                                })
                            }),
                        error: getFieldError(form.mobileResult, (function (field_errors) {
                                return field_errors.mobile;
                              })),
                        input_image: icons.phone,
                        clear_input: (function ($$event) {
                            Curry._2(form.updateMobile, (function (input, param) {
                                    return {
                                            pickup_address: input.pickup_address,
                                            drop_address: input.drop_address,
                                            name: input.name,
                                            mobile: "",
                                            requirement: input.requirement,
                                            consent_for_callback: input.consent_for_callback
                                          };
                                  }), $$event.target.value);
                          })
                      }), React.createElement(SpotEstimateRequirementCmp$PorterinFeature.make, {
                        label_error: {
                          label: labels.requirement,
                          error: getFieldError(form.requirementResult, (function (field_errors) {
                                  return field_errors.requirement;
                                }))
                        },
                        requirement: form.input.requirement,
                        form: form,
                        requirement_content: spot_fare_estimate_vm.requirement_options,
                        children: React.createElement("div", {
                              className: styles["requirement-input"]
                            }, requirementString(undefined)),
                        icon: icons.requirement,
                        is_filled: requirementString(undefined).length === 0
                      })), React.createElement("div", {
                  className: styles["checkbox-input"],
                  onClick: (function (param) {
                      Curry._2(form.updateConsent_for_callback, (function (input, param) {
                              return {
                                      pickup_address: input.pickup_address,
                                      drop_address: input.drop_address,
                                      name: input.name,
                                      mobile: input.mobile,
                                      requirement: input.requirement,
                                      consent_for_callback: !form.input.consent_for_callback
                                    };
                            }), form.input.consent_for_callback);
                    })
                }, React.createElement("input", {
                      checked: form.input.consent_for_callback,
                      name: "whatspp-consent",
                      type: "checkbox"
                    }), React.createElement("p", {
                      className: styles.text
                    }, spot_fare_estimate_vm.consent_label)), React.createElement("div", {
                  className: styles["save-details-wrapper"]
                }, React.createElement("button", {
                      className: styles["save-details"],
                      disabled: form.submitting,
                      onClick: (function (param) {
                          PublishEventsHelper$PorterinFeature.publishEvents(city_selected_context.category, GAEventsConstants$PorterinFeature.submitButtonGaEvent(city_selected_context.category, service_category), undefined);
                          if (locale === LocaleConstants$PorterinUtils.en_AE) {
                            PublishEventsHelper$PorterinFeature.publishEvents(city_selected_context.category, GAEventsConstants$PorterinFeature.gaFareEstimateClickUae, undefined);
                          }
                          Curry._1(form.submit, undefined);
                        })
                    }, form.submitting ? React.createElement("div", {
                            className: styles.loading
                          }) : spot_fare_estimate_vm.submit_icon_label.label), React.createElement("div", {
                      className: styles["submit-button-error"]
                    }, getFormErrorMessage(undefined))));
}

var make = SpotEstimateFormFieldCmp;

export {
  styles ,
  make ,
}
/* styles Not a pure module */
